/**
 * Accent tones.
 *
 * Each tone is a CSS class that sets --tone (text/rules) and --tone-bg
 * (tint) locally, so components stay colour-agnostic: a tag, a card rule
 * or a column heading just reads the variables. See the "Accent tones"
 * block in styles.css.
 *
 * Tints are low-saturation on purpose - colour is used to help the reader
 * tell sections apart, not to decorate.
 */

export const TONES = ['t-green', 't-clay', 't-amber', 't-rose', 't-plum', 't-teal', 't-olive'];

// Plant categories.
const CATEGORY_TONES = {
  fruit_trees: 't-clay',
  flowering_plants: 't-rose',
  perennials: 't-green',
  seasonal_plants: 't-amber',
  vegetables: 't-olive',
};

// Growing-guide categories, as authored in data/guides.js.
const GUIDE_TONES = {
  Techniques: 't-plum',
  Pruning: 't-clay',
  Bulbs: 't-rose',
  Vegetables: 't-olive',
  Lawn: 't-green',
  Problems: 't-amber',
  Watering: 't-teal',
};

export function categoryTone(value) {
  return CATEGORY_TONES[value] || 't-green';
}

export function guideTone(category) {
  return GUIDE_TONES[category] || 't-green';
}
